import React from "react";
import Layout from "../components/_App/layout";
import SEO from "../components/_App/seo";
import Navbar from "../components/_App/Navbar";
import Footer from "../components/_App/Footer";
import PageBanner from '../components/Common/PageBanner';
import SingleFeatures from '../components/Features/SingleFeatures';
import PeraOzellikler from "../components/Features/PeraOzellikler";
import PeraOzellikler2 from "../components/Features/PeraOzellikler2";
import Shape1 from "../assets/images/shape1.png";
import Shape2 from "../assets/images/shape2.svg";
import Shape3 from "../assets/images/shape3.svg";
import Shape4 from "../assets/images/shape4.svg";
import Shape5 from "../assets/images/shape5.png";
import ProSteelOzellikler from "../components/Features/ProSteelOzellikler";
import ProSteelOzellikler2 from "../components/Features/ProSteelOzellikler2";

const ProSteel = () => (
    <Layout>
        <SEO title="Pro Steel Çelik Konstrüksiyon Üretim Takip Yazılımı" />

        <Navbar />

        <div className="page-title-area">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <h2>Pro Steel</h2>
                        <p>Çelik Konstrüksiyon Üretim Takip Yazılımı</p>
                        <a
                            href="https://prosteel.pixelyazilim.com.tr/"
                            className="btn btn-demo"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Demo İçin Tıklayınız
                        </a>
                    </div>
                </div>
            </div>

            {/* Shape Images */}
            <div className="shape1">
                <img src={Shape1} alt="shape" />
            </div>
            <div className="shape2 rotateme">
                <img src={Shape2} alt="shape" />
            </div>
            <div className="shape3">
                <img src={Shape3} alt="shape" />
            </div>
            <div className="shape4">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape5">
                <img src={Shape5} alt="shape" />
            </div>
            <div className="shape6 rotateme">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape7">
                <img src={Shape4} alt="shape" />
            </div>
            <div className="shape8 rotateme">
                <img src={Shape2} alt="shape" />
            </div>
        </div>



        <ProSteelOzellikler />

        <ProSteelOzellikler2 />

        <Footer />
    </Layout>
)

export default ProSteel;
